import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { Typography } from '../../../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../../../context/ViewContext/ViewContext.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import { classNames } from '../../../../utils/functions/classNames/classNames.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import { useKYCFlag } from '../../../../utils/hooks/useKYCFlag/useKYCFlag.js';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../../components/IconButton/IconButton.js';
import { getWalletVerifiedCredential } from '../../../../utils/functions/getWalletVerifiedCredential/getWalletVerifiedCredential.js';
import { useWidgetContext } from '../../context/DynamicWidgetContext.js';
import { EmptyWallets } from '../EmptyWallets/EmptyWallets.js';
import { Wallet } from '../Wallet/Wallet.js';

const DynamicWidgetWallets = () => {
    const { secondaryWallets, user } = useInternalDynamicContext();
    const { setNewWalletId, availableWalletsContainerRef } = useWidgetContext();
    const isEmpty = secondaryWallets.length === 0;
    const isKYCEnabled = useKYCFlag();
    return (jsxs("div", Object.assign({ ref: availableWalletsContainerRef, className: 'dynamic-widget-wallets', "data-testid": 'dynamicWidgetWallets' }, { children: [!isKYCEnabled && (jsx(Typography, Object.assign({ weight: 'regular', variant: 'body_normal', color: 'secondary', className: 'dynamic-widget-wallets__title' }, { children: "My wallets" }))), jsx("div", Object.assign({ className: classNames('available-wallets__body', {
                    'dynamic-widget-wallets__body--apply-height': !isEmpty,
                }) }, { children: isEmpty ? (jsx(EmptyWallets, {})) : (jsx("div", Object.assign({ className: 'available-wallets__wallet-list' }, { children: secondaryWallets.map((wallet, index) => {
                        var _a;
                        return (jsx(Wallet, { ens: (_a = getWalletVerifiedCredential(wallet, user === null || user === void 0 ? void 0 : user.verifiedCredentials)) === null || _a === void 0 ? void 0 : _a.nameService, wallet: wallet, setNewWalletId: setNewWalletId }, wallet.id));
                    }) }))) }))] })));
};

export { DynamicWidgetWallets };
